import React from 'react'

const IdIcon = ({ color }) => {
  return (
    <svg
      width="17"
      height="22"
      viewBox="0 0 17 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5733 2.57892H14.6955V1.01164C14.6955 0.775939 14.5044 0.584961 14.2688 0.584961H0.426681C0.191117 0.584961 0 0.775939 0 1.01164V18.7411C0 18.9768 0.191117 19.1678 0.426681 19.1678H2.30452V21.0626C2.30452 21.2983 2.49564 21.4893 2.7312 21.4893H16.5733C16.8089 21.4893 17 21.2983 17 21.0626V3.0056C17 2.76989 16.8089 2.57892 16.5733 2.57892ZM16.1466 3.43228V11.4652H14.6955V3.43228H16.1466ZM13.8421 1.43832V9.47261H8.66778V9.13038C8.66778 8.05034 7.89776 7.04989 6.83689 6.75155C5.91547 6.49252 4.67821 6.49279 3.75735 6.75155C2.6962 7.04976 1.92617 8.05021 1.92617 9.13038V9.47261H0.853361V1.43832H13.8421ZM7.81442 9.47261H2.77954V9.13038C2.77954 8.42494 3.28789 7.76992 3.98846 7.57297C4.75877 7.35671 5.83491 7.35643 6.60577 7.57297C7.30607 7.76992 7.81442 8.42494 7.81442 9.13038V9.47261V9.47261ZM0.853361 10.326H13.8421V18.3144H0.853361V10.326ZM3.15788 20.6359V19.1678H14.2688C14.5044 19.1678 14.6955 18.9768 14.6955 18.7411V12.3185H16.1466V20.6359H3.15788Z"
        fill={color}
      />
      <path
        d="M5.2868 5.91869C6.22794 5.91869 6.99352 5.15311 6.99352 4.21197C6.99352 3.27083 6.22794 2.50525 5.2868 2.50525C4.34566 2.50525 3.58008 3.27083 3.58008 4.21197C3.58008 5.15311 4.34566 5.91869 5.2868 5.91869ZM5.2868 3.35861C5.75737 3.35861 6.14016 3.7414 6.14016 4.21197C6.14016 4.68254 5.75737 5.06533 5.2868 5.06533C4.81623 5.06533 4.43344 4.68254 4.43344 4.21197C4.43344 3.7414 4.81623 3.35861 5.2868 3.35861Z"
        fill={color}
      />
      <path d="M12.5061 3.1217H9.23486V3.97507H12.5061V3.1217Z" fill={color} />
      <path
        d="M12.5061 5.06543H9.23486V5.91879H12.5061V5.06543Z"
        fill={color}
      />
      <path
        d="M12.5061 7.00916H9.23486V7.86252H12.5061V7.00916Z"
        fill={color}
      />
      <path
        d="M12.6244 16.7262V11.8919C12.6244 11.6562 12.4333 11.4652 12.1978 11.4652H2.66301C2.42745 11.4652 2.23633 11.6562 2.23633 11.8919V16.7262C2.23633 16.9619 2.42745 17.1529 2.66301 17.1529H12.1978C12.4333 17.1529 12.6244 16.9619 12.6244 16.7262ZM11.7711 13.8824H6.31896V12.3186H11.7711V13.8824ZM5.4656 12.3186V13.8824H3.08969V12.3186H5.4656ZM3.08969 14.7357H5.4656V16.2995H3.08969V14.7357V14.7357ZM6.31896 16.2995V14.7357H11.7711V16.2995H6.31896Z"
        fill={color}
      />
    </svg>
  )
}

export default IdIcon
